namespace Areas.Account.ValidFund{
    "use strict";

    let currentValidFund: any;
    let selectedAccount: any;
    let selectedFund: any;


    export function onSelectionChanged(e: any) {
        var selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            selectedAccount = selectedRows[0].projectCCNumber;
            selectedFund = selectedRows[0].fundingSourceCode;
        }
    }

    export function onValidFundContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);
    }

    export function onNewValidFundRow(e: any) {
        currentValidFund = e.data;
        currentValidFund.accountId = e.component.option("AccountId");
        currentValidFund.projectCCNumber = e.component.option("ProjectCCNumber");
        currentValidFund.accountName = e.component.option("AccountName");
        currentValidFund.projectId = e.component.option("ProjectId");
        selectedAccount = e.component.option("ProjectCCNumber");
    }

    export function onEditingStart(e: any) {
        currentValidFund = e.data;
        selectedAccount = e.data.projectCCNumber;
        selectedFund = e.data.fundingSourceCode;
    }

    export function updateValidFund() {
        const grid = $("#ValidFundGrid").dxForm("instance");
        const newData: any = grid.option("gridData");
        const result: any = grid.validate();
        const keyId: any = grid.option("KeyId");

        if (result.isValid && keyId != null) {
            sendRequest(`/Account/FinanceValidFund/Put/${keyId}`, JSON.stringify(newData), "PUT");
        }
    }

    export function selectAccount() {
        const grid: any = $("#ValidFundGrid").dxDataGrid("instance");
        const parameters = { projectId: grid.option("ProjectId") };

        const projectLookupDialog =
            new Areas.Dialogs.Project.ProjectLookupDialog(dialogAccountClosing, parameters);
    }

    function dialogAccountClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#ValidFundGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateAccountGridRow(dataGrid, rowIndex, data);
    }

    function getItemRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentValidFund === undefined || currentValidFund === null) {
            return rowIndex;
        } else if (currentValidFund.accountValidFundId) {
            rowIndex = dataGrid.getRowIndexByKey(currentValidFund.accountValidFundId);
        }

        return rowIndex;
    }

    function updateAccountGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "accountId", data.accountId);
        dataGrid.cellValue(rowIndex, "projectCCNumber", data.projectCCNumber);
        dataGrid.cellValue(rowIndex, "accountName", data.accountName);

        currentValidFund.accountId = data.accountId;
        currentValidFund.projectCCNumber = data.projectCCNumber;
        currentValidFund.accountName = data.accountName;

        selectedAccount = data.projectCCNumber;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onRowInserted(e: any) {
        selectedAccount = e.component.option("ProjectCCNumber");
        currentValidFund = null;
    }

    export function editAccountTemplate(cellElement, cellInfo) {
        let projectCCNumber = !selectedAccount ? "Select..." : selectedAccount;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${projectCCNumber}</div><div class="dx-lookup-arrow" id="account-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectAccount);
        cellElement.append(html);
    }


    //select Funding Source
    export function selectFundingSource() {
        const fundingSourceDialog = new Areas.Dialogs.FundingSourceDialog(dialogClosing);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#ValidFundGrid").dxDataGrid("instance");

        var rowIndex = getItemRowIndex(dataGrid);
        updateGridRow(dataGrid, rowIndex, data);
    }

    function updateGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "fundingSourceId", data.fundingSourceId);
        dataGrid.cellValue(rowIndex, "fundingSourceCode", data.fundingSourceCode);
        dataGrid.cellValue(rowIndex, "fundingSourceName", data.fundingSourceName);
        dataGrid.cellValue(rowIndex, "fundingSourceDescription", data.fundingSourceDescription)
        dataGrid.cellValue(rowIndex, "fundMaturityDate", data.fundMaturityDate);

        currentValidFund.fundingSourceId = data.fundingSourceId;
        currentValidFund.fundingSourceCode = data.fundingSourceCode;
        currentValidFund.fundingSourceName = data.fundingSourceName;
        currentValidFund.fundingSourceDescription = data.fundingSourceDescription;
        currentValidFund.fundMaturityDate = data.fundMaturityDate;

        dataGrid.repaintRows([rowIndex]);
    }

    export function editFundingSourceTemplate(cellElement, cellInfo) {
        let fundingSourceCode = !cellInfo.data.fundingSourceCode ? "Select..." : cellInfo.data.fundingSourceCode;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${fundingSourceCode}</div><div class="dx-lookup-arrow" id="funding-source-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectFundingSource);
        cellElement.append(html);
    }
}